import { Order, MainWorkOrder, SubWorkOrder, Person, Machine, Material, Product, Workflow } from '@/types';
import { HistoryEntry } from '@/types/history';
import ordersData from '@/data/orders.json';
import mainWorkOrdersData from '@/data/main-work-orders.json';
import subWorkOrdersData from '@/data/sub-work-orders.json';
import personsData from '@/data/persons.json';
import machinesData from '@/data/machines.json';
import materialsData from '@/data/materials.json';
import productsData from '@/data/products.json';
import workflowsData from '@/data/workflows.json';
import {
  loadPersonsFromStorage,
  loadHistoryFromStorage,
  savePersonsToStorage,
  saveHistoryToStorage,
} from '@/utils/localStorage';

// 載入所有參考資料
export async function loadReferenceData() {
  // 嘗試從 localStorage 載入人員資料 | Try to load persons from localStorage
  const storedPersons = loadPersonsFromStorage();
  const storedHistory = loadHistoryFromStorage();

  // 模擬異步載入
  const data = {
    orders: ordersData as Order[],
    mainWorkOrders: mainWorkOrdersData as MainWorkOrder[],
    subWorkOrders: subWorkOrdersData as SubWorkOrder[],
    persons: (storedPersons || personsData) as Person[],
    machines: machinesData as Machine[],
    materials: materialsData as Material[],
    products: productsData as Product[],
    workflows: workflowsData as Workflow[],
    personHistory: (storedHistory || []) as HistoryEntry[],
  };

  // 如果 localStorage 沒有資料，保存初始資料 | If no localStorage data, save initial data
  if (!storedPersons) {
    savePersonsToStorage(data.persons);
  }
  if (!storedHistory) {
    saveHistoryToStorage(data.personHistory);
  }

  return Promise.resolve(data);
}

// 載入單一資料類型
export async function loadOrders(): Promise<Order[]> {
  return ordersData as Order[];
}

export async function loadMainWorkOrders(): Promise<MainWorkOrder[]> {
  return mainWorkOrdersData as MainWorkOrder[];
}

export async function loadSubWorkOrders(): Promise<SubWorkOrder[]> {
  return subWorkOrdersData as SubWorkOrder[];
}

export async function loadPersons(): Promise<Person[]> {
  // 嘗試從 localStorage 載入 | Try to load from localStorage
  const storedPersons = loadPersonsFromStorage();
  if (storedPersons) {
    return storedPersons;
  }
  return personsData as Person[];
}

export async function loadMachines(): Promise<Machine[]> {
  return machinesData as Machine[];
}

export async function loadMaterials(): Promise<Material[]> {
  return materialsData as Material[];
}

export async function loadProducts(): Promise<Product[]> {
  return productsData as Product[];
}

export async function loadWorkflows(): Promise<Workflow[]> {
  return workflowsData as Workflow[];
}
